import { Alert, Modal, Skeleton, notification } from "antd";
import TagList from "./TagList";
import TagSelect from "./TagSelect";
import { useEffect, useState } from "react";
import { ListDomainLeadsRequest, ListDomainLeadsResponse } from "../api/models";
import APIClient from "../api/api";

export interface Props {
    listRequest: ListDomainLeadsRequest
    onClose: (updated: boolean) => void
}

const maxToShow = 10;

const TagAll = (props: Props) => {
    const [tags, setTags] = useState<string[]>([]);
    const [sampleDomains, setSampleDomains] = useState<ListDomainLeadsResponse>();
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        loadSampleDomains();
    }, []);

    async function loadSampleDomains() {
        const leads = await APIClient.listDomainLeads({ page: 1, pageSize: maxToShow + 1 }, props.listRequest);
        setSampleDomains(leads);
    }

    function onSelectTags(tags: string[]) {
        setTags(tags);
    }

    async function onTagAll() {
        try {
            setSaving(true);
            await APIClient.listDomainLeads({page: 1, pageSize: maxToShow}, {
                tagAll: tags,
                ...props.listRequest});
            notification.success({message: 'All domains have been tagged.'});
            props.onClose(true);
        } catch(e) {
            notification.error({message: 'Failed to tag domains at this time.'});
        } finally {
            setSaving(false);
        }
    }

    console.log(props.listRequest);

    return (
        <Modal cancelButtonProps={{ disabled: !sampleDomains || saving}} confirmLoading={saving} onOk={onTagAll}
                okButtonProps={{ disabled: !sampleDomains || tags.length == 0 || saving }} width="800px" title="Tag all domains" open onCancel={() => props.onClose(false)} okText="Tag All">
            <Skeleton loading={!sampleDomains}>
                {sampleDomains ?
                    <div>
                        <p>Select below to add tags to multiple domains.</p>
                        <TagSelect allowNew placeholder="Choose tags" onChange={onSelectTags} />
                        <p>There are {sampleDomains.content.length} domains that will be tagged.</p>
                        <ul>
                            {sampleDomains.content.slice(0, Math.min(sampleDomains.content.length, maxToShow)).map(domain => (
                                <li key={domain.domain}>{domain.domain}</li>
                            ))}
                            {sampleDomains.content.length > maxToShow ? <li>...</li> : ''}
                        </ul>
                        <Alert type="warning" message="Are you sure you want to continue?" />
                    </div> : ''}
            </Skeleton>
        </Modal>
    )
};
export default TagAll;
